export const ATTENTION_HEALTH = new Set([
  'failed',
  'unconfirmed',
  'delivery_attention',
]);
